import { setCurrentMenuItemClass } from './helper/helper';

// menu classes
(function () {
	setCurrentMenuItemClass();

	jQuery('h1,p,a,span,dl,td,li:not(.wp-block-navigation-item)').each(function (i, elem) {
		jQuery(elem).html(function (i, html) {
			return html
				.replace(/((?!<sup>\s*))&reg;((?!\s*<\/sup>))/gi, '<sup>&reg;</sup>')
				.replace(/((?!<sup>\s*))®((?!\s*<\/sup>))/gi, '<sup>&reg;</sup>')
		});
	});
}());